import { Component, HostBinding } from '@angular/core';

@Component({
  template: '',
})
export class BlankComponent {
  @HostBinding('class.blank-layout') blankLayout: boolean = true;
}
